import { render, staticRenderFns } from "./ReportDataTableComponent.vue?vue&type=template&id=27ce9f84"
import script from "./ReportDataTableComponent.vue?vue&type=script&lang=js"
export * from "./ReportDataTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports